<template>
  <div class="list-container disp-scroll">
    <!-- インポート用モーダル -->
    <ModalExcelImport
      :isShowModal="isModalExcelImport"
      :addImport="addImport"
      :allcontents="allcontents"
      :getAllContentsList="getAllContentsList"
      @cancel="changeModalExcelImport"
    />
    <!-- モーダル END -->
    <!-- 変更履歴モーダル -->
    <ModalEmploymentChangeHistory
      :isShowModal="isModalEmploymentChangeHistory"
      :contentId="selectContentId"
      @cancel="changeModalEmploymentChangeHistory"
      v-if="isModalEmploymentChangeHistory"
    />
    <!-- 変更履歴モーダル END-->
    <!-- モーダル START - 画像 -->
    <b-modal width="680px" :active.sync="isModalImage">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
              画像を選択（{{selectedGroup.length}}件選択中）
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            画像を下記から選ぶことができます（<a href="https://unsplash.com/">Unsplash</a>）
            <div style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('job')">仕事1</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('work')">仕事2</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('meeting')">仕事3</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('care')">介護・福祉・リハビリ1</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('health')">介護・福祉・リハビリ2</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('elderly care')">介護・福祉・リハビリ3</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('nurse')">医療</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('sales')">営業</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('shop')">販売</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('education')">教育</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('designer')">デザイン</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('hotel')">旅行・ホテル</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('real estate')">不動産</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('finance')">金融</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('transportation')">運輸・輸送</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('programming')">IT・Web</button>
              <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('engineer')">エンジニア</button>
            </div>
            <hr>
            <ul class="horizontal-image disp-scroll">
              <li v-for="photo in photos" :key="photo.id">
                <img @click="saveImageAPI(photo)" class="image-list" height="300" width="300" :src="photo.urls.thumb" alt="img"/>
              </li>
            </ul>
            <hr>
            <b-field position="is-centered" style="text-align: center !important;">
              <div class="upload-form">
                <a class="upload-style">
                  <label for="file_upload" class="upload-style">
                    <a class="button is-primary"
                    @click="openSelectModal">
                      <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から画像を選択する
                    </a>
                    <ModalSelectMedia @updated="selectImage"></ModalSelectMedia>
                  </label>
                </a>
              </div>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- モーダル END - 画像 -->
    <ModalCreatePage ref="modalCreatePage"/>
    <div class="header-em">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Pages</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">求人紹介ページ / カスタムページ作成画面</p>
      </div>
      <div class="header-menu">
        <span style="font-size: 16px; font-weight: 500; color: #EE2C98; margin-right: 24px; margin-top: 8px;">求人件数：{{cntCompanyCount}}件</span>
        <b-tooltip label="求人インポート" position="is-bottom">
          <button id="employment-import" class="button is-primary" style="margin-right: 10px;" @click="changeModalExcelImport(true)"><span class="mdi mdi-file-import"></span></button>
        </b-tooltip>
        <b-tooltip label="求人エクスポート" position="is-bottom">
          <button id="employment-export" class="button is-primary" style="margin-right: 10px;" @click="excelExportAll()"><span class="mdi mdi-file-export"></span></button>
        </b-tooltip>
        <b-tooltip label="求人の設定" position="is-bottom">
          <router-link to="template"><button id="employment-setting" class="button is-primary" style="margin-right: 10px;"><span class="mdi mdi-table-settings"></span></button></router-link>
        </b-tooltip>
        <b-tooltip label="求人の作成" position="is-bottom">
          <button id="employment-create" class="button is-primary" @click="modalCreatePage" style="margin-right: 10px;"><span class="mdi mdi-table-row-plus-before"></span></button>
        </b-tooltip>
        <b-tooltip label="カスタムページの作成" position="is-bottom">
          <button id="employment-custom" class="button is-primary" @click="moveToEditorCreateCustom()" style="margin-right: 24px;"><span class="mdi mdi-map-plus"></span></button>
        </b-tooltip>
      </div>
    </div>
    <!-- pagination -->
    <div style="margin-top: 8px; margin-bottom: 16px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; width: calc(100% - 80px);">
      <div style="display: flex; width: 40%;">
        <div class="tabs is-toggle is-small" style="margin: 0; display: contents;">
          <ul>
            <li :class="{'is-active': isRecruitPage}" >
              <a @click="isRecruitPage=true " v-if="!isContentsLoading">求人紹介ページ</a>
              <a v-if="isContentsLoading">求人紹介ページ</a>
            </li>
            <li :class="{'is-active': !isRecruitPage}">
              <a @click="isRecruitPage=false" v-if="!isContentsLoading">カスタムページ</a>
              <a v-if="isContentsLoading">カスタムページ</a>
            </li>
          </ul>
        </div>
        <input style="width: 300px; margin-left: 16px; font-size: 14px; border-top-right-radius: 0; border-bottom-right-radius: 0;" class="input" placeholder="場所・仕事内容などを検索" v-model="query" />
        <button style="font-size: 14px; border-top-left-radius: 0; border-bottom-left-radius: 0;" class="button is-primary" @click="searchContents()"><span class="mdi mdi-cloud-search-outline"></span></button>
      </div>
      <b-pagination
            :total="cntCompanyCount"
            :current.sync="pages"
            :per-page="30"
            v-if="isRecruitPage">
      </b-pagination>
    </div>
    <!-- 求人紹介ページ -->
    <table class="recruit-table" v-if="contents.length > 0 && isRecruitPage">
      <!-- ローディングページ -->
      <div class="init-page" v-if="isContentsLoading||isBulkCreate">
        <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
      </div>
      <thead>
      <tr>
        <th v-for="(t, i) in tableHeader" :key="i" v-if="t !== 'ロボ' && t !== 'シェア'">
          <div style="display: flex; justify-content: center; align-items: center; height: 40px;">
            <b-checkbox type="is-light" @input="allSelect()" v-if="i==0"></b-checkbox>
            <p>{{t}}</p>
            <div style="display: flex; flex-direction: column; margin-left: 8px; font-size: 18px;" v-if="i == 3 || i == 4 || i == 5">
              <a @click="sortContents(i, true)" style="color: white;"><span class="mdi mdi-chevron-up"></span></a>
              <a @click="sortContents(i, false)" style="color: white;"><span class="mdi mdi-chevron-down"></span></a>
            </div>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(c, index) in contents" :key="index" style="transition: 0.5s;" :style="selectedStyle(c.contents_id)" v-if="c.layout == 4">
        <td style="font-size: 18px; font-weight:800;">
          <b-checkbox v-model="selectedGroup" :native-value="c"></b-checkbox>
        </td>
        <td v-if="c.manage_tags.length > 0">
          <div v-for="(tag, index) in c.manage_tags" style="display: inline-block;">
            <b-tag class="manage-tag" style="margin: 1px;" type="is-primary">{{ tag.name }}</b-tag>
          </div>
        </td>
        <td v-else>
          <b-tag style="margin: 1px;" type="is-primary">設定なし</b-tag>
        </td>
        <td style="display: flex; justify-content: flex-start; align-items: flex-start;">
          <img style="width: 80px; height: 60px; margin-right: 10px; border-radius: 10px; object-fit: cover;" :src="getImageURL(c)"/>
          <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column;">
            <p style="text-align: left;">{{getSubString(c.content.title, 30)}}</p>
            <b-tag style="margin: 5px;" type="is-primary">{{getSubString(c.content.work_title, 15)}}</b-tag>
            <div style="margin: 5px; width: 100%;" align="left">
              <button class="button is-small" @click="moveToEditor(c)" >編集する</button>
              <button class="button is-small" @click="OpenDeleteModal(c)">削除する</button>
            </div>
          </div>
        </td>
        <td>
          <p>{{getPublic(c.is_public)}}</p>
          <a style="font-size: smaller; font-weight: 600; margin-top: 8px;" @click="selectChangePublic(c, !c.is_public)">{{getPublic(!c.is_public)}}にする</a>
        </td>
        <td>{{c.pv_count}}</td>
        <td>{{c.cv_count}}</td>
        <td>
          <button @click="previewDemo(c)" class="button is-primary"><span class="mdi mdi-play"></span></button>
        </td>
        <td>
          <button @click="preview(c)" class="button is-primary" v-if="c.is_public"><span class="mdi mdi-link-variant"></span></button>
          <button class="button is-primary" v-else disabled><span class="mdi mdi-link-variant"></span></button>
        </td>
        <td>
          <button @click="selectContentChangeHistory(c)" class="button is-primary"><span class="mdi mdi-file-multiple"></span></button>
        </td>
      </tr>
      </tbody>
    </table>
    <!-- ローディングページ - インポート用 -->
    <div class="init-page" v-if="isLoadingImport">
      <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
    </div>
    <!-- カスタムページ -->
    <table class="recruit-table" v-if="contents.length > 0 && !isRecruitPage">
      <!-- ローディングページ -->
      <div class="init-page" v-if="isContentsLoading">
        <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
      </div>
      <tr>
        <th v-for="(t, i) in tableCustomHeader" :key="i">
          <b-checkbox type="is-light" @input="allSelect()" v-if="i==0"></b-checkbox>
          <p>{{t}}</p>
        </th>
      </tr>
      <tr v-for="(c, index) in contents" :key="index" style="transition: 0.5s;" :style="selectedStyle(c.contents_id)" v-if="c.layout == 5">
        <td style="font-size: 18px; font-weight:800;">
          <b-checkbox v-model="selectedGroup" :native-value="c"></b-checkbox>
        </td>
        <td style="display: flex; justify-content: flex-start; align-items: flex-start;">
          <img style="width: 80px; height: 60px; margin-right: 10px; border-radius: 10px; object-fit: cover;" :src="getImageURL(c)"/>
          <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column; width: calc(100% - 80px);">
            <p style="text-align: left;">{{getSubString(c.title, 20)}}</p>
            <div style="margin: 5px; width: 100%;" align="left">
              <button class="button is-small" @click="moveToEditor(c)" >編集する</button>
              <button class="button is-small" @click="OpenDeleteModal(c)">削除する</button>
            </div>
          </div>
        </td>
        <td>
          <p>{{getPublic(c.is_public)}}</p>
          <a style="font-size: smaller; font-weight: 600; margin-top: 8px;" @click="selectChangePublic(c, !c.is_public)">{{getPublic(!c.is_public)}}にする</a>
        </td>
        <td>{{c.pv_count}}</td>
        <td style="min-width: 150px;">
          <div class="share-box">
            <div style="height: 20px;">
              <a target="_blank" :href="getFaceBookUrl(c)">
                <img style="height: 32px; width: 32px;" src="@/assets/template/facebook_logo.png"/>
              </a>
            </div>
            <div style="height: 20px;">
              <a target="_blank" :href="getLineUrl(c)">
                <img style="height: 32px; width: 32px;" src="@/assets/template/line_logo.png"/>
              </a>
            </div>
            <div style="height: 20px;">
              <a target="_blank" :href="getTwitterUrl(c)">
                <img style="height: 32px; width: 32px;" src="@/assets/template/twitter_logo.png"/>
              </a>
            </div>
          </div>
        </td>
        <td>
          <button @click="previewDemo(c)" class="button is-primary"><span class="mdi mdi-play"></span></button>
        </td>
        <td>
          <button @click="preview(c)" class="button is-primary" v-if="c.is_public"><span class="mdi mdi-link-variant"></span></button>
          <button class="button is-primary" v-else disabled><span class="mdi mdi-link-variant"></span></button>
        </td>
      </tr>
    </table>
    <!-- pagination -->
    <div style="margin-top: 16px;">
      <b-pagination
            :total="cntCompanyCount"
            :current.sync="pages"
            :per-page="30"
            v-if="isRecruitPage">
      </b-pagination>
    </div>
    <!-- Footer -->
    <div class="select-footer" v-if="selectedGroup.length > 0">
      <img style="width: 80px; height: 80px; background: white; border-radius: 50%; margin-left: 20px;" src="@/assets/lp/hrmonster.png" />
      <div style="margin-bottom: 8px;" class="message-box">
        <p>今、{{selectedGroup.length}}件選択中です！ 下記のコマンドを実行できますが、どうしますか？</p>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsCopy()" v-if="isRecruitPage">コピー</button>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="searchPhotos('job');isModalImage=true">画像変更</button>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsDelete()">削除</button>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsChangePublic(true)">公開設定</button>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsChangePublic(false)">非公開設定</button>
        <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectedGroup=[]">キャンセル</button>
      </div>
    </div>
    <!-- 削除時のモーダル -->
    <b-modal width="500px" :active.sync="deleteModalFlg" :on-cancel="deletePageCancel">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 20px;">
            求人ページの削除
          </p>
        </header>
        <div class="card-content">
          <p style="margin-bottom: 16px;">選択中求人ページ:<span style="margin-left: 8px; font-weight: bold;">{{getSubString(selectDeletePage.title, 20)}}</span></p>
          <h2 style="font-size: 16px; margin-bottom: 16px; color: red;">一度削除した求人ページは元に戻すことができません。<br>本当に選択した求人ページを削除してもよろしいですか？</h2>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 140px;" class="button" @click="deletePageCancel('cancel')">キャンセル</button>
            <button style="width: 140px;" class="button is-danger" @click="deleteContent(selectDeletePage)">削除する</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState }          from 'vuex'
import csv2json              from '@/functions/csv2json'
import url2base64            from '@/functions/url2base64'
import ModalCreatePage       from '@/components/ui/ModalCreatePage'
import ModalSelectMedia      from '@/components/ui/ModalSelectMedia'
import Tooltip               from '@/components/atoms/tooltips/Tooltip'
import ModalSitemapRoboApply from '@/components/organisms/users/sitemap/ModalSitemapRoboApply'
import ModalExcelImport      from '@/components/EmploymentPage/ModalExcelImport'
import ModalEmploymentChangeHistory      from '@/components/EmploymentPage/ModalEmploymentChangeHistory'
// 外部関数
import {
  SITEMAP_ACTION_TYPE,
  SITEMAP_OVERALL,
  SITEMAP_CONTENT_TYPE,
  SITEMAP_DISPATCH,
} from '@/functions/users/sitemapFunc'
export default {
  components: {
    ModalCreatePage,
    ModalSelectMedia,
    Tooltip,
    ModalSitemapRoboApply,
    ModalExcelImport,
    ModalEmploymentChangeHistory,
},
  data () {
    return {
      search: '',
      photos: [],
      shareText: '採用募集中です！',
      // 求人一覧のテーブルヘッダー
      tableHeader: [
        '',
        '管理タグ',
        'タイトル',
        'ステータス',
        'PV数',
        '応募',
        'ロボ',
        'シェア',
        'プレビュー',
        '公開リンク',
        '変更履歴',
      ],
      // カスタムページ一覧のテーブルヘッダー
      tableCustomHeader: [
        '',
        'タイトル',
        'ステータス',
        'PV数',
        'シェア',
        'プレビュー',
        '公開リンク'
      ],
      isRecruitPage: true,
      isModalCSV: false,
      isModalExcelImport: false,
      isModalExcelExport: false,
      isModalImage: false,
      isModalEmploymentChangeHistory: false,
      isLoadingSitemap: true,
      files: [],
      csv: [],
      sep: ',',
      selectedGroup:[],
      pages: 1,
      query: '',
      deleteModalFlg: false,
      selectDeletePage: {},
      isSitemapRoboApplyModalOpen: false,
      applyRoboTargetSitemamp: {},
      allcontents: [],
      selectContentId: '',
      isAllSelect: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['contents', 'isContentsLoading', 'rank', 'cntCount', 'cntCompanyCount', 'isBulkCreate', 'rootContents', 'isLoadingImport']),
    ...mapState('mediapool', ['images']),
    ...mapState('sitemap', ['sitemapRoboList', 'sitemapRecruitListAll']),
  },
  created () {
    this.initPageList()
  },
  watch: {
    '$route.query.recruit' () {
      this.selectedGroup = []
      this.isRecruitPage = this.$route.query.recruit == 'true' ? true : false
      if (this.$route.query.q) {
        this.query = this.$route.query.q
        this.$store.dispatch('employmentPage/getContentsQuery', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage + '&q=' + this.query)
      } else {
        this.$store.dispatch('employmentPage/getContentsList', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage)
      }
    },
    '$route.query.q' () {
      this.selectedGroup = []
      this.query = this.$route.query.q
      if (this.$route.query.q) {
        this.$store.dispatch('employmentPage/getContentsQuery', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage + '&q=' + this.query)
      }
    },
    pages () {
      if (this.$route.query.pages) {
        if (Number(this.$route.query.pages) >= 1) {
          if (this.$route.query.q) {
            this.query = this.$route.query.q
            if (this.$route.query.sortflg) {
              this.$store.dispatch('employmentPage/getContentsSort', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, sortflg: this.$route.query.sortflg, idx: this.$route.query.idx, query: this.query, userHash: this.user.userHash})
              this.$router.push('/dashboard/employment/list?pages=' + this.pages + '&recruit=' + this.isRecruitPage + '&sortflg=' + this.$route.query.sortflg + '&idx=' + this.$route.query.idx)
            } else {
              this.query = this.$route.query.q
              this.$store.dispatch('employmentPage/getContentsQuery', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
              this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage + '&q=' + this.query)
            }
          } else {
            if (this.$route.query.sortflg) {
              this.$store.dispatch('employmentPage/getContentsSort', {pages: Number(this.pages), isRecruitPage: this.$route.query.recruit, sortflg: this.$route.query.sortflg, idx: this.$route.query.idx, query: this.query, userHash: this.user.userHash})
              this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.$route.query.recruit + '&sortflg=' + this.$route.query.sortflg + '&idx=' + this.$route.query.idx)
            } else {
              this.$store.dispatch('employmentPage/getContentsList', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, userHash: this.user.userHash})
              this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage)
            }
          }
        }
      }
    },
    isRecruitPage () {
      this.pages = 1
      this.selectedGroup = []
      if (this.$route.query.q) {
        this.query = this.$route.query.q
        this.$store.dispatch('employmentPage/getContentsQuery', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage + '&q=' + this.query)
      } else {
        this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + this.pages + '&recruit=' + this.isRecruitPage)
      }
    }
  },
  methods: {
    initPageList (updateFlg) {
      if (this.$route.query.recruit == 'true') {
        // 求人ページ
        this.isRecruitPage = true
      } else {
        // カスタムページ
        this.isRecruitPage = false
      }
      if (this.$route.query.pages) {
        // リストの取得処理
        if (Number(this.$route.query.pages) >= 1) {
          this.pages = Number(this.$route.query.pages)
          // クエリが設定されていた場合は、内容を引き継ぐ
          if (this.$route.query.q) {
            this.query = this.$route.query.q
          }
          if (this.$route.query.sortflg){
            // ソートフラグが設定されている時（ソート処理の中で検索クエリでの絞り込みも行える）
            this.$store.dispatch('employmentPage/getContentsSort', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, sortflg: this.$route.query.sortflg, idx: this.$route.query.idx, query: this.query, userHash: this.user.userHash})
          } else if (this.$route.query.q) {
            // ソートフラグは設定されていないが、検索クエリは設定されている時
            this.$store.dispatch('employmentPage/getContentsQuery', {pages: this.pages, isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
          } else {
            // ソートフラグも検索クエリも設定されていない時
            this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage, userHash: this.user.userHash})
          }
        }
      } else {
        // 初期化
        this.pages = 1
        if (this.isRecruitPage) {
          this.$router.push('/dashboard/employment/list?pages=' + this.pages + '&recruit=true')
        } else {
          this.$router.push('/dashboard/employment/list?pages=' + this.pages + '&recruit=false')
        }
      }
    },
    getSubString (m, num) {
      if (m) {
        // タイトルが数字だけのパターンも許容されてしまう為、文字列に変換する
        m = m.toString()
        return m.length < num ? m : m.substring(0, num - 3) + '...'
      } else {
        return 'no title'
      }
    },
    searchContents () {
      // エラーチェック
      this.pages = 1
      if (this.query && this.query.length > 0) {
        this.$store.dispatch('employmentPage/getContentsQuery', {pages: this.pages, isRecruitPage: this.isRecruitPage, query: this.query, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=' + Number(this.pages) + '&recruit=' + this.isRecruitPage + '&q=' + this.query)
      } else {
        this.$store.dispatch('employmentPage/getContentsList', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, userHash: this.user.userHash})
        this.$router.push('/dashboard/employment/list?pages=1&recruit=' + this.isRecruitPage)
      }
    },
    sortContents (idx, sortflg) {
      // エラーチェック
      this.$store.dispatch('employmentPage/getContentsSort', {pages: Number(this.pages), isRecruitPage: this.isRecruitPage, sortflg: sortflg, idx: idx, query: this.query, userHash: this.user.userHash})
      if (this.query) this.$router.push('/dashboard/employment/list?pages=1&recruit=' + this.isRecruitPage + '&sortflg=' + sortflg + '&idx=' + idx + '&q=' + this.query)
      else this.$router.push('/dashboard/employment/list?pages=1&recruit=' + this.isRecruitPage + '&sortflg=' + sortflg + '&idx=' + idx)
    },
    allSelect () {
      if (this.isAllSelect){
        this.selectedGroup = []
        this.isAllSelect = false
      } else {
        this.selectedGroup = this.contents
        this.isAllSelect = true
      }
    },
    onFileChangeImage (e) {
      let files = e.target.files || e.dataTransfer.files
      let reader = new FileReader()
      reader.onload = (e) => {
        for (var i in this.selectedGroup) {
          this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: this.selectedGroup[i].contents_id, data: e.target.result, is_original: true})
        }
        this.selectedGroup = []
      }
      reader.readAsDataURL(files[0])
      this.isModalImage = false
    },
    saveImageAPI (photo) {
      for (var i in this.selectedGroup) {
        this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: this.selectedGroup[i].contents_id, data: photo, is_original: false})
      }
      this.selectedGroup = []
      this.isModalImage = false
    },
    searchPhotos (search) {
      let appid = this.$unsplash._applicationId
      let query  = search
      this.$axios.get(`https://api.unsplash.com/search/photos/?page=1&per_page=30&query=${query}&client_id=${appid}&width=1920&height=1080`)
      .then(response => {
        this.photos = response.data.results
      })
      .catch(e => {
        console.log(JSON.stringify(e))
      })
    },
    selectedStyle (id) {
      for (var j in this.selectedGroup) {
        if (id == this.selectedGroup[j].contents_id) {
          return {
            background: 'rgba(230, 50, 100, 0.5)'
          }
        }
      }
    },
    selectsDelete () {
      for (var i in this.selectedGroup) {
        this.deleteContent(this.selectedGroup[i])
      }
      this.selectedGroup = []
    },
    selectChangePublic(cnt, flg) {
      cnt.is_public = flg
      this.changeContent(cnt)
    },
    selectsChangePublic(flg) {
      for (var i in this.selectedGroup) {
        var cnt = null
        cnt = this.selectedGroup[i]
        cnt.is_public = flg
        this.changeContent(cnt)
      }
      this.selectedGroup = []
    },
    selectsCopy () {
      for (var i in this.selectedGroup) {
        var cnt = null
        cnt = this.selectedGroup[i]
        this.copyContent(cnt)
      }
      this.selectedGroup = []
      alert('コピー完了いたしました。')
    },
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      console.log(e.target.files)
      let reader = new FileReader()
      reader.onload = (e) => {
        this.csv = csv2json(e.target.result, this.sep)
        this.$store.dispatch('employmentPage/postContentImport', this.csv)
      }
      reader.readAsText(files[0])
      this.isModalCSV = false
    },
    getImageURL (c) {
      var url = ''
      if (c.is_image_original) {
        url = c.image
      } else {
        if (c.image_unsplash) {
          url = c.image_unsplash.urls['thumb'] ? c.image_unsplash.urls.thumb : c.image_unsplash.urls.raw
        } else {
          url = c.image_url
        }
      }
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (url == '') return defaultURL
      else return url
    },
    debug () {
      console.debug('*** Start *** debug')
      alert(JSON.stringify(this.contents))
      console.debug('*** End *** debug')
    },
    getLayout (layout) {
      console.debug('*** Start *** getLayout')
      console.debug('layout: ' + JSON.stringify(layout))
      switch (layout) {
        case 0:
          console.debug('Title disp')
          return 'タイトル画面'
          break
        case 1:
          console.debug('content type 1')
          return 'コンテンツタイプ１'
          break
        case 2:
          console.debug('content type 2')
          return 'コンテンツタイプ２'
          break
        case 3:
          console.debug('content type 3')
          return 'コンテンツタイプ３'
          break
      }
      console.debug('*** End *** getLayout')
    },
    getUrl (p) {
      console.debug('*** Start *** getUrl')
      console.debug('p: ' + JSON.stringify(p))
      var url = process.env.LOC_HOST + '/recruit/' + this.user.companyID + '/' + p.contents_id
      console.debug('url: ' + url)
      console.debug('*** End *** getUrl')
      return url
    },
    getLineUrl (p) {
      console.debug('*** Start *** getSubStr')
      console.debug('p: ' + JSON.stringify(p))
      return 'http://line.me/R/msg/text/?' + process.env.LOC_HOST + '/recruit/' + this.user.companyID + '/' + p.contents_id
    },
    getTwitterUrl (p) {
      console.debug('*** Start *** getTwitterUrl')
      console.debug('p: ' + JSON.stringify(p))
      var urlHttps = 'https://twitter.com/share?url='
      var urlHttp  = 'http://twitter.com/share?url='
      if (process.env.NODE_ENV === 'development') return urlHttp + process.env.LOC_HOST + '/recruit/' + this.user.companyID + '/' + p.contents_id
      else return urlHttps + process.env.LOC_HOST + '/recruit/' + this.user.companyID + '/' + p.contents_id
    },
    getFaceBookUrl (p) {
      console.debug('*** Start *** getFaceBookUrl')
      console.debug('p: ' + JSON.stringify(p))
      return 'https://www.facebook.com/sharer/sharer.php?u=' + process.env.LOC_HOST + '/recruit/' + this.user.companyID + '/' + p.contents_id
    },
    preview (c) {
      console.debug('*** Start *** preview')
      console.debug('c: ' + JSON.stringify(c))
      var url = ''
      if (this.isRecruitPage) {
        url = process.env.LOC_HOST + '/recruit/detail/' + this.user.companyID + '/' + c.contents_id
      } else {
        url = process.env.LOC_HOST + '/cstm/' + this.user.companyID + '/' + c.contents_id
      }
      var h = window.outerHeight
      var w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
      console.debug('*** End *** preview')
    },
    previewDemo (c) {
      console.debug('*** Start *** preview')
      console.debug('c: ' + JSON.stringify(c))
      var url = ''
      if (this.isRecruitPage) {
        url = process.env.LOC_HOST + '/recruit/demo/' + this.user.companyID + '/' + c.contents_id
      } else {
        url = process.env.LOC_HOST + '/cstm/demo/' + this.user.companyID + '/' + c.contents_id
      }
      var h = window.outerHeight
      var w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
      console.debug('*** End *** preview')
    },
    moveToEditor (p) {
      console.debug('*** Start *** moveToEditor')
      console.debug('p: ' + JSON.stringify(p))
      this.$store.dispatch('employmentPage/setEditContent', p)
        .then(() => this.$router.push('/dashboard/employment/editor/' + p.contents_id  + '?pages=' + this.pages + '&recruit=' + this.isRecruitPage))
      console.debug('*** Start *** moveToEditor')
    },
    moveToEditorCreateCustom () {
      console.debug('*** Start *** moveToEditorCreateCustom')
      var newContent = {
        contents_id: 'new',
        layout: 5,
        title: 'no title',
        is_main: false,
        content: {
          layout_type: 5,
          list: []
        },
        image: '',
        image_unsplash: null,
        is_image_original: false
      }
      this.$store.dispatch('employmentPage/setEditContentCustom', newContent)
        .then(() => this.$router.push('/dashboard/employment/editor/new' + '?pages=' + this.pages + '&recruit=' + this.isRecruitPage))
    },
    deleteContent (c) {
      console.debug('*** Start *** deleteContent')
      console.debug('c: ' + JSON.stringify(c))
      this.$store.dispatch('employmentPage/deleteContent', c)
      .then(() => {
        this.deleteModalFlg = false
      })
      console.debug('*** End *** deleteContent')
    },
    changeContent (c) {
      console.debug('*** Start *** changeContent')
      console.debug('c: ' + JSON.stringify(c))
      this.$store.dispatch('employmentPage/putContents',
        {
          content: c,
          pages: this.$route.query.pages ? this.$route.query.pages : 1
        }
      )
      console.debug('*** End *** changeContent')
    },
    copyContent (c) {
      console.debug('*** Start *** changeContent')
      console.debug('c: ' + JSON.stringify(c))
      var image_data = null
      if (c.is_image_original) {
        image_data = ''
      } else image_data = c.image_unsplash
      // 表示タグ、管理タグの情報を格納
      const displayTagIds = c.display_tags.map(tag => tag.id)
      const manageTagIds = c.manage_tags.map(tag => tag.id)
      var setJson = {
        content: c.content,
        is_image_original: c.is_image_original,
        'image_data': image_data,
        'top_department': c.top_department,
        'second_department': c.second_department,
        'third_department': c.third_department,
        'display_tags': displayTagIds,
        'manage_tags': manageTagIds,
      }
      setJson.content.title = '（コピー）' + setJson.content.title
      this.$store.dispatch('employmentPage/postContentsRecruit', {content: setJson, pages: this.$route.query.pages ? this.$route.query.pages : 1, layout: 4})
      console.debug('*** End *** changeContent')
    },
    getPublic (flg) {
      console.debug('*** Start *** getPublic')
      console.debug('flg: ' + JSON.stringify(flg))
      if (flg) return '公開'
      else return '非公開'
    },
    modalCreatePage () {
      if (this.rootContents.length > 0) {
        this.$refs.modalCreatePage._data.isModalActive = true
      } else {
        alert('求人の設定ボタンより、求人設定をしてください。')
      }
    },
    excelExport () {
      this.$store.dispatch('employmentPage/excelExport', this.selectedGroup)
      this.selectedGroup = []
    },
    excelExportAll () {
      this.$store.dispatch('employmentPage/excelExportAll', {companyID: this.user.companyID, userHash: this.user.userHash})
    },
    openSelectModal () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    selectImage (id) {
      for (let s of this.selectedGroup) {
        this.$store.dispatch('employmentPage/postMainContentImage', {contents_id: s.contents_id, data: id, is_original: true})
      }
      this.isModal = false
    },
    OpenDeleteModal (c) {
      this.selectDeletePage = c
      this.deleteModalFlg = true
    },
    closeDeleteModal () {
      this.deleteModalFlg = false
    },
    deletePageCancel (c) {
      if (c === 'cancel') {
        this.deleteModalFlg = false
      }
      this.selectDeletePage = {}
    },
    getCountSitemapRobo (c) {
      if (this.sitemapRecruitListAll.length === 0) return 0
      let count = 0
      for (let i in this.sitemapRecruitListAll) {
        // 求人ページ一致
        if (this.sitemapRecruitListAll[i].contents.contents_id === c.contents_id) {
          // ロボリスト有
          if (this.sitemapRecruitListAll[i].apply_robo_list.length > 0) {
            count += this.sitemapRecruitListAll[i].apply_robo_list.length
          }
          if (this.sitemapRecruitListAll[i].apply_minirobo_list.length > 0) {
            count += this.sitemapRecruitListAll[i].apply_minirobo_list.length
          }
        }
      }
      // 集計結果を返す
      return count
    },
    getIconSitemapRobo (c) {
      if (this.sitemapRecruitListAll.length === 0) return
      for (let i in this.sitemapRecruitListAll) {
        // 求人ページ一致
        if (this.sitemapRecruitListAll[i].contents.contents_id === c.contents_id) {
          // 初回起動ロボあり
          if (this.sitemapRecruitListAll[i].start_robo) {
            return this.getIconPage(this.sitemapRecruitListAll[i].start_robo)
          } else if (this.sitemapRecruitListAll[i].start_minirobo) {
            return this.getIconPage(this.sitemapRecruitListAll[i].start_minirobo)
          }
          // ロボリスト有
          if (this.sitemapRecruitListAll[i].apply_robo_list.length > 0) {
            return this.getIconPage(this.sitemapRecruitListAll[i].apply_robo_list[0])
          }
          if (this.sitemapRecruitListAll[i].apply_minirobo_list.length > 0) {
            return this.getIconPage(this.sitemapRecruitListAll[i].apply_minirobo_list[0])
          }
        }
      }
      return require('@/assets/template/robot.png')
    },
    getIconPage (robo) {
      if (robo.data.icon != '') {
        return robo.data.icon
      } else if (robo.data.icon_ref != '') {
        return robo.data.icon_ref
      } else if (robo.data.default_icon_ref != '') {
        return robo.data.default_icon_ref
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    getRoboName (c) {
      if (this.sitemapRecruitListAll.length === 0) return 'ロボの設置がありません。'
      let message = ''
      let start_robo_id = null
      let start_minirobo_id = null
      for (let i in this.sitemapRecruitListAll) {
        // 求人ページ一致
        if (this.sitemapRecruitListAll[i].contents.contents_id === c.contents_id) {
          // 初回起動ロボあり
          if (this.sitemapRecruitListAll[i].start_robo) {
            message += '初回起動ロボ: ' + this.sitemapRecruitListAll[i].start_robo.data.name + '\n'
            start_robo_id = this.sitemapRecruitListAll[i].start_robo.data.bot_id
          } else if (this.sitemapRecruitListAll[i].start_minirobo) {
            message += '初回起動ロボ: ' + this.sitemapRecruitListAll[i].start_minirobo.data.name + '\n'
            start_minirobo_id = this.sitemapRecruitListAll[i].start_minirobo.data.bot_id
          } else {
            message += '初回起動ロボ: なし\n'
          }
          message += '設置ロボ: '
          // ロボリスト有
          if (this.sitemapRecruitListAll[i].apply_robo_list.length > 0) {
            for (let j in this.sitemapRecruitListAll[i].apply_robo_list) {
              if (start_robo_id != this.sitemapRecruitListAll[i].apply_robo_list[j].data.bot_id)
              message += this.sitemapRecruitListAll[i].apply_robo_list[j].data.name + ', '
            }
            message = message.slice(0, -2)
          }
          if (this.sitemapRecruitListAll[i].apply_minirobo_list.length > 0) {
            for (let j in this.sitemapRecruitListAll[i].apply_minirobo_list) {
              if (start_minirobo_id != this.sitemapRecruitListAll[i].apply_minirobo_list[j].data.bot_id)
              message += this.sitemapRecruitListAll[i].apply_minirobo_list[j].data.name + ', '
            }
            message = message.slice(0, -2)
          }
          // 設置なしの場合
          if (this.sitemapRecruitListAll[i].apply_robo_list.length === 0 && this.sitemapRecruitListAll[i].apply_minirobo_list.length === 0) {
            message += 'なし'
          }
        }
      }
      return message
    },
    returnRoboApplyModal (roboApplyTarget, selectRobo, isRecruit) {
      this.closeRoboApplyModal()
      const updateList = [{
        target: roboApplyTarget,
        robo  : [selectRobo]
      }]
      const updateData = {
        update_list: updateList,
        action     : SITEMAP_ACTION_TYPE.ROBO_APPLY,
        is_mini    : selectRobo.is_mini,
      }
      const pageData = {
        pages       : 0,
        per_page    : 0,
        content_type: SITEMAP_CONTENT_TYPE.RECRUIT_PAGE
      }
      const sendData = {
        update_data: updateData,
        page_data  : pageData
      }
      this.$store.dispatch(SITEMAP_DISPATCH.UPDATE_SITEMAP_RECRUIT, sendData)
        .then(() => {this.$forceUpdate()})
    },
    openRoboApplyModal (target) {
      let content = null
      for (let i in this.sitemapRecruitListAll) {
        if (target.contents_id === this.sitemapRecruitListAll[i].contents.contents_id) {
          content = this.sitemapRecruitListAll[i]
        }
      }
      this.applyRoboTargetSitemamp = content
      this.isSitemapRoboApplyModalOpen = true
    },
    closeRoboApplyModal () {
      this.isSitemapRoboApplyModalOpen = false
    },
    changeModalExcelImport (flg) {
      this.isModalExcelImport = flg
    },
    addImport (data) {
      this.$store.dispatch('employmentPage/excelImport', data)
      this.isModalExcelImport = false
    },
    // 変更履歴モーダル処理
    selectContentChangeHistory(content){
      this.selectContentId = content.contents_id
      this.changeModalEmploymentChangeHistory(true)
    },
    // 変更履歴モーダルの表示処理
    changeModalEmploymentChangeHistory (flg) {
      this.isModalEmploymentChangeHistory = flg
    },
    getSitemap () {
      this.$store.dispatch('sitemap/getSitemapRecruitListAll')
        .then((data) => {
          this.isLoadingSitemap = false
        })
    },
    getRootContent () {
      this.$store.dispatch('employmentPage/getRootContent')
    },
    getAllContentsList () {
      this.$store.dispatch('employmentPage/getAllContentsList')
        .then((data) => {
          this.allcontents = data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-em {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 初期ページ用 -- start -- */
.init-page {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10000;
}
.head-content {
  background: #FEFEFE;
}
.head-message {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 1.2em;
  width: 50%;
  min-width: 300px;
}
.make-pic {
  width : 100%;
  height: 100%;
}
.init-top-box {
  height: 30%;
  width: 90%;
  text-align: left;
  padding: 20px;
  padding-top: 0;
  background: #f0f2ff;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
}
.init-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 64px;
}
/* 初期ページ用 -- end -- */
.list-container {
  position: relative;
  margin: 0;
  height: 100vh;
  width: 100%;
  background: #FEFEFE;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
table td:not([align]), table th:not([align]) {
  text-align: center;
  font-size: smaller;
}
table{
  border-collapse:collapse;
  margin: 0 auto;
}
td, th{
  padding: 10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
th {
  height: 48px !important;
  color:#fff;
  background:#AA0066;
  position: sticky;
  top: 0;
  z-index: 1000;
}
table tr:nth-child(odd){
  background:#ffeeff;
}
thead {
  background:#AA0066;
  position: sticky;
  top: 0;
  z-index: 1000;
}
.first-create {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 70%;
  color: #fff;
  font-size: 1.4em;
  font-weight: 700;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background: rgba(20, 22, 22, 0.55);
  transition:all 0.3s ease-in-out;
}
.first-create:hover {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  width: 100%;
}
.list-header {
  width: 90%;
  height: 85px;
  border-bottom: solid 3px #2c3e50;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title-header {
  padding-left: 25px;
  text-align: left;
  font-size: 24px;
  font-weight: 800;
}
.recruit-table {
  width: calc(100% - 50px);
  position: relative;
}
.tag-container {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.main-tag {
  font-size: 1.2em;
  font-weight: 700;
  background-color: #00C4A7;
  color: white;
  width: 300px;
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}
.employments-container{
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-x: scroll;
  padding: 15px;
  background: white;
}
.content-card {
  margin: 5px;
  border-radius: 5px;
  width: 24%;
  min-width: 210px;
  cursor: pointer;
}
.content-card:hover {
  background: rgb(220, 231, 231);
  transform: scale(1.05);
}
.job-card {
  margin: 5px;
  border-radius: 5px;
  max-width: 300px;
  min-width: 300px;
  cursor: pointer;
}
.job-card:hover {
  background: rgb(220, 231, 231);
  transform: scale(1.05);
}
.btn-circle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border-radius: 50%;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  overflow : hidden;
	outline : none;
  z-index: 2;
  filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.6));
}
.share-box {
  display: flex;
  justify-content: space-around;
  padding: 5px;
}
.content-box {
  height: 100px;
}
.upload-form {
  position: relative;
}
.upload-style {
  width: 200px;
  border-radius: 10px;
}
.upload-style > input {
  display: none;
}
.select-footer {
  position: fixed;
  bottom: 0;
  left: 200px;
  width: calc(100vw - 200px);
  height: 150px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  transition: 0.5s;
}
.message-box {
  margin-left: 20px;
  height: 90px;
  width: calc(100% - 160px);
  border: solid 3px white;
  border-radius: 15px;
  border-top-left-radius: 0px;
  text-align: left;
  padding: 10px 20px;
}

.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.horizontal-image {
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  height: 300px;
  width: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.horizontal-image li {
  background: #fff;
  margin: 2px;
  text-align: center;
  width: 230px;
}
.image-list {
  width: 230px;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  height: 100px;
  max-height: 100px;
  min-height: 100px;
}
.table-td p{
  vertical-align: middle;
  overflow: scroll;
  height: 100px;
  max-height: 100px;
  min-height: 100px;
}
.table-th {
  min-width: 100px;
  max-width: 100px;
  width: 100px;
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.import-check {
  margin-left: 8px;
  position: relative;
  top: 3px;
}
/deep/.tooltip {
  div {
    text-align: left;
  }
}
.manage-tag {
  display: inline-block;
  margin: 1px;
  max-width: 6em; /* 表示タグ、管理タグの省略表示の起点を変更する場合はここを修正する */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/EmploymentPageList.vue